// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-summer-adult-motorcycle-half-finger-gloves",
  "entries": [
    {
      "id": "33461240922302",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps9-black-white-background-main-20260717.jpg?v=1784260488",
      "alt": "color:Black | batch:sps9-whitebg-20260717 | role:white-background-main | Seibertron SPS-9 black white background main image"
    },
    {
      "id": "33374617960638",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-01.jpg?v=1783398334",
      "alt": "color:Black | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 01"
    },
    {
      "id": "33374617993406",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-02.jpg?v=1783398334",
      "alt": "color:Black | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 02"
    },
    {
      "id": "33374618026174",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-03.jpg?v=1783398334",
      "alt": "color:Black | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 03"
    },
    {
      "id": "33374618058942",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-04.jpg?v=1783398334",
      "alt": "color:Black | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 04"
    },
    {
      "id": "33374618091710",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-05.jpg?v=1783398334",
      "alt": "color:Black | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 05"
    },
    {
      "id": "33461240955070",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps9-red-white-background-main-20260717.jpg?v=1784260488",
      "alt": "color:Red | batch:sps9-whitebg-20260717 | role:white-background-main | Seibertron SPS-9 red white background main image"
    },
    {
      "id": "33374618124478",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-06.jpg?v=1783398334",
      "alt": "color:Red | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 06"
    },
    {
      "id": "33374618157246",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-07.jpg?v=1783398334",
      "alt": "color:Red | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 07"
    },
    {
      "id": "33374618190014",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-08.jpg?v=1783398334",
      "alt": "color:Red | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 08"
    },
    {
      "id": "33374618222782",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-09.jpg?v=1783398334",
      "alt": "color:Red | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 09"
    },
    {
      "id": "33374618255550",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-10.jpg?v=1783398334",
      "alt": "color:Red | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 10"
    },
    {
      "id": "33461240987838",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps9-yellow-white-background-main-20260717.jpg?v=1784260488",
      "alt": "color:Yellow | batch:sps9-whitebg-20260717 | role:white-background-main | Seibertron SPS-9 yellow white background main image"
    },
    {
      "id": "33374618288318",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-11.jpg?v=1783398334",
      "alt": "color:Yellow | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 11"
    },
    {
      "id": "33374618321086",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-12.jpg?v=1783398334",
      "alt": "color:Yellow | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 12"
    },
    {
      "id": "33374618353854",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-13.jpg?v=1783398334",
      "alt": "color:Yellow | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 13"
    },
    {
      "id": "33374618386622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-14.jpg?v=1783398334",
      "alt": "color:Yellow | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 14"
    },
    {
      "id": "33374618419390",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-15.jpg?v=1783398334",
      "alt": "color:Yellow | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 15"
    },
    {
      "id": "33461241020606",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps9-white-white-background-main-20260717.jpg?v=1784260488",
      "alt": "color:White | batch:sps9-whitebg-20260717 | role:white-background-main | Seibertron SPS-9 white white background main image"
    },
    {
      "id": "33374618452158",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-16.jpg?v=1783398334",
      "alt": "color:White | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 16"
    },
    {
      "id": "33374618484926",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-17.jpg?v=1783398334",
      "alt": "color:White | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 17"
    },
    {
      "id": "33374618517694",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-18.jpg?v=1783398334",
      "alt": "color:White | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 18"
    },
    {
      "id": "33374618550462",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-19.jpg?v=1783398334",
      "alt": "color:White | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 19"
    },
    {
      "id": "33374618583230",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps9-half-finger-gallery-20.jpg?v=1783398334",
      "alt": "color:White | Seibertron SPS-9 summer carbon fiber half-finger motorcycle gloves image 20"
    }
  ],
  "variants": [
    {
      "id": "45294980137150",
      "title": "Black / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Black",
        "Adult XS"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983217342",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983250110",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983282878",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983315646",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983348414",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983381182",
      "title": "Black / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXXL"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983413950",
      "title": "Black / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Black",
        "Youth XS"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983446718",
      "title": "Black / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Black",
        "Youth S"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983479486",
      "title": "Black / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Black",
        "Youth M"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983512254",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294983545022",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33461240922302"
    },
    {
      "id": "45294980333758",
      "title": "Red / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Red",
        "Adult XS"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983577790",
      "title": "Red / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Red",
        "Adult S"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983610558",
      "title": "Red / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Red",
        "Adult M"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983643326",
      "title": "Red / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Red",
        "Adult L"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983676094",
      "title": "Red / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Red",
        "Adult XL"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983708862",
      "title": "Red / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXL"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983741630",
      "title": "Red / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXXL"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983774398",
      "title": "Red / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Red",
        "Youth XS"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983807166",
      "title": "Red / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Red",
        "Youth S"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983839934",
      "title": "Red / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Red",
        "Youth M"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983872702",
      "title": "Red / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Red",
        "Youth L"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294983905470",
      "title": "Red / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Red",
        "Youth XL"
      ],
      "mediaId": "33461240955070"
    },
    {
      "id": "45294980530366",
      "title": "Yellow / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "Yellow",
        "Adult XS"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294983938238",
      "title": "Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Yellow",
        "Adult S"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294983971006",
      "title": "Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Yellow",
        "Adult M"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984003774",
      "title": "Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Yellow",
        "Adult L"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984036542",
      "title": "Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Yellow",
        "Adult XL"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984069310",
      "title": "Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Yellow",
        "Adult XXL"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984102078",
      "title": "Yellow / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Yellow",
        "Adult XXXL"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984134846",
      "title": "Yellow / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "Yellow",
        "Youth XS"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984167614",
      "title": "Yellow / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "Yellow",
        "Youth S"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984200382",
      "title": "Yellow / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "Yellow",
        "Youth M"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984233150",
      "title": "Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Yellow",
        "Youth L"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294984265918",
      "title": "Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Yellow",
        "Youth XL"
      ],
      "mediaId": "33461240987838"
    },
    {
      "id": "45294980726974",
      "title": "White / Adult XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XS"
        }
      ],
      "values": [
        "White",
        "Adult XS"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984298686",
      "title": "White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "White",
        "Adult S"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984331454",
      "title": "White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "White",
        "Adult M"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984364222",
      "title": "White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "White",
        "Adult L"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984396990",
      "title": "White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "White",
        "Adult XL"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984429758",
      "title": "White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "White",
        "Adult XXL"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984462526",
      "title": "White / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "White",
        "Adult XXXL"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984495294",
      "title": "White / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "White",
        "Youth XS"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984528062",
      "title": "White / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "White",
        "Youth S"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984560830",
      "title": "White / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "White",
        "Youth M"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984593598",
      "title": "White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "White",
        "Youth L"
      ],
      "mediaId": "33461241020606"
    },
    {
      "id": "45294984626366",
      "title": "White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "White",
        "Youth XL"
      ],
      "mediaId": "33461241020606"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
